import { Form, Input } from "antd";

// Optional buyer details printed on this user's invoices (past and future).
// Fill in only when a CP/MF asks for them; leave empty for a plain invoice.
const InvoiceDetailsFields = () => (
  <div style={{ marginTop: 8, paddingTop: 16, borderTop: "1px solid #f0f0f0" }}>
    <div style={{ fontWeight: 600, marginBottom: 4 }}>Invoice details (optional)</div>
    <div style={{ color: "#8c8c8c", fontSize: 12, marginBottom: 12 }}>
      Only when requested. Shown under "Billed to" on all of this user's invoices.
    </div>
    <Form.Item label="Company name" name="billingCompanyName">
      <Input placeholder="e.g. Example Consulting Ltd." maxLength={200} />
    </Form.Item>
    <Form.Item label="Address" name="billingAddress">
      <Input.TextArea
        placeholder="Paste the address as sent, one line per row"
        autoSize={{ minRows: 3, maxRows: 6 }}
        maxLength={600}
      />
    </Form.Item>
    <Form.Item label="Tax ID" name="billingTaxId">
      <Input placeholder="e.g. 0105551234567 (Head Office) or PL5260001234" maxLength={100} />
    </Form.Item>
  </div>
);

// Form values for the user being edited. Always set all three, so details from a
// previously edited user can never linger in the form (older records lack the fields).
export const invoiceDetailsInitial = (user) => ({
  billingCompanyName: user?.billingCompanyName || "",
  billingAddress: user?.billingAddress || "",
  billingTaxId: user?.billingTaxId || "",
});

export const invoiceDetailsPayload = (values) => ({
  billingCompanyName: (values.billingCompanyName || "").trim(),
  billingAddress: (values.billingAddress || "").trim(),
  billingTaxId: (values.billingTaxId || "").trim(),
});

export default InvoiceDetailsFields;
